<div class="db-cdn-enable-banner" [ngClass]="{'long': !!longSize, 'forHosting': !!forHosting}" *ngIf="(status === 'not-enabled' || status === 'pending')">
  <div class="db-cdn-enable-banner__header">
    <div *ngIf="status !== 'not-enabled'">
      <h1>{{ step === 1 ? 'Verify domain ownership to enable CDN' : 'Point your domain to Cloudflare'}}</h1>
      <p class="mt4" *ngIf="status === 'pending'">Finish all the necessary steps to fully enjoy the benefits of Pro optimization on your website.</p>
      <p class="mt4" *ngIf="status !== 'pending'">Finish the last step to finalize CDN activation for a faster, better performing & more secure website.</p>
    </div>
    <div *ngIf="status === 'not-enabled'">
      <h1>Pro optimization hasn’t been applied yet</h1>
      <p class="mt4">You have upgraded to 10Web Booster Pro but haven’t enabled<br *ngIf="!longSize">
        the Pro optimization on your website. Enable CDN to enjoy the benefits.</p>
    </div>
    <div *ngIf="status === 'not-enabled'">
      <input class="ds-switcher ds-control-small" type="checkbox" id="enable-cdn" (change)="enableCdn()">
      <label for="enable-cdn">
        <span class="ds-switcher-control"></span>
      </label>
    </div>
  </div>
  <div class="db-pro-optim-section-options mt20">
    <div class="db-pro-optim-section-option" *ngFor="let option of options">
      <div class="db-pro-optim-section-option-text" [innerHTML]="option.text"></div>
      <img src="{{option.img}}"/>
    </div>
  </div>
  <div class="db-cdn-enable-banner__steps mt25" *ngIf="status !== 'not-enabled' && cloudflareEnabled">
    <p>Step {{step}}/2</p>
    <b (click)="redirect()">Continue</b>
  </div>
</div>
